<template>
  <v-text-field
    v-mask="maskTemplate"
    :value="value"
    :autofocus="autofocus"
    persistent-placeholder
    clear-icon="ui-icon-close-not-a-circle"
    hide-details
    clearable
    outlined
    type="tel"
    inputmode="numeric"
    v-bind="$attrs"
    @input.native="emitInput"
    @focus="handleFocus"
    @blur="handleBlur"
    @click:clear="$emit('input', undefined)"
  />
</template>

<script setup lang="ts">
import { mask } from 'vue-the-mask'
import { ref, nextTick, watch } from 'vue'
import { getFormattedPrice } from 'www/utils'

const emit = defineEmits(['input'])
const props = defineProps<{
  value?: number
  min?: number
  max?: number
  autofocus?: boolean
  isVisible: boolean
}>()

const vMask = mask
const baseMask = '#########'
const maskTemplate = ref(baseMask)

const getMaskPrice = (price?: number) => {
  const formattedPrice = getFormattedPrice(price, { textForZero: false })

  return formattedPrice ? formattedPrice.replace(/\d/g, '#') : baseMask
}

watch(() => props.isVisible, async () => {
  if (!props.isVisible) {
    return
  }

  maskTemplate.value = baseMask
  await nextTick() // Ждём когда v-mask обновит DOM
  maskTemplate.value = getMaskPrice(props.value)
}, { immediate: true })

const emitInput = ({ target, isTrusted }: Event) => {
  if (!(target instanceof HTMLInputElement)) { return }

  if (!isTrusted) { return }

  const cleanInput = `${target.value}`.replace(/\D/g, '')
  const inputNumber = parseInt(cleanInput, 10)

  emit('input', Number.isNaN(inputNumber) ? undefined : inputNumber)
}

const handleFocus = () => {
  maskTemplate.value = baseMask
}

const handleBlur = async () => {
  if (props.min !== undefined && props.value !== undefined && props.value < props.min) {
    emit('input', props.min)

    await nextTick() // Ждём когда v-mask обновит DOM
    maskTemplate.value = getMaskPrice(props.min)
  } else if (props.max !== undefined && props.value !== undefined && props.value > props.max) {
    emit('input', props.max)

    await nextTick() // Ждём когда v-mask обновит DOM
    maskTemplate.value = getMaskPrice(props.max)

    return
  }

  await nextTick() // Ждём когда v-mask обновит DOM
  maskTemplate.value = getMaskPrice(props.value)
}
</script>
